<template>
  <div style="font-family: 'Courier New', Courier, monospace;" class="mt-0">
    <div class="text-center">
      <span v-if="userData.logo != 0"
        ><img :src="getFiles(userData.logo)" height="40"
      /></span>
      <span v-else><img src="@/assets/images/logo.png" height="40"/></span
      ><br />
      <h4 style="color:black" class="text-uppercase">
        {{ userData.business }}
      </h4>
      <span style="color:black;font-size:13px"
        >Location : {{ userData.location }}</span
      ><br />
      <span style="color:black;font-size:13px"
        >Telephone : {{ userData.contact }}</span
      ><br /><br />
      <span
        style="color: black;font-size:13px"
        class="text-decoration-underline"
        ><b> PAYMENT RECEIPT</b></span
      ><br />
      <span style="color:black;font-size:13px">
        Receipt No : {{ this.$route.query.id }}</span
      ><br />
      <span style="color:black;font-size:13px"> Date : {{ addedon }}</span> <br/>
       <span style="color:black;font-size:13px"> Order No : {{ transaction_id }}</span>
    </div>
    <table class="table table-sm mt-1" style="color: black;" density="compact">
      <thead>
        <tr>
          <th>Qty</th>
          <th>Item Name</th>
          <!-- <th>Unit Price</th> -->
          <th>Total</th>
        </tr>
      </thead>
      <tbody>
        <tr v-for="item in ordersbyid" :key="item.id">
          <td>{{ item.quantity }} {{ item.unit }}</td>
          <td>{{ item.product }}</td>
          <!-- <td>{{ commas(item.price) }}</td> -->
          <td>{{ commas(item.price * item.quantity) }}</td>
        </tr>
      </tbody>
    </table>
    <div class="mt-2 text-center">
      <span style="color: black;font-size:14px"
        ><b> Amount Paid : Ugx.{{ commas(amountpaid) }}</b></span
      ><br />
      <span v-if="amountpaid>=price_recorded" style="color: black;font-size:14px"
        ><b> Change : Ugx.{{ commas(amountpaid - price_recorded) }}</b></span
      >
      <span v-else style="color: black;font-size:14px"
        ><b> Balance : Ugx.{{ commas(price_recorded - amountpaid) }}</b></span
      ><br /><br />
      <h6 style="color: black;" class="my-4 text-center">
        Signature : .........................
      </h6>
      <p style="color:black;font-size:13px">
        Printed by : {{ userData.username }} <br />Thanks for Supporting Us.
        <br />
        Printed Via Pharma Tech Software <br />
        www.afrimedsolutions.com
      </p>
    </div>
  </div>
</template>

<script>
import appConfig from "@/app.config";
import axios from "axios";
export default {
  page: {
    title: "Print Reciept",
    meta: [{ name: "description", content: appConfig.description }],
  },
  data() {
    return {
      userData: JSON.parse(localStorage.getItem("user")),
      ordersbyid: [],
      addedon: "",
      amount: "",
      amountpaid: "",
      price_recorded: "",
      transaction_id:'',
          };
  },
  methods: {
    async showticket() {
      this.transaction_id = this.$route.query.id;
      let url = `/orderbyid/${this.transaction_id}`;
      await axios.get(url).then((response) => {
        this.ordersbyid = response.data.orders;
      });
    },

    async showOrder() {
      this.transaction_id = this.$route.query.id;
      let url = `/showorderbyid/${this.transaction_id}`;
      await axios.get(url).then((response) => {
        this.addedon = response.data.order[0].added_on;
        this.amount = response.data.order[0].amount;
      });
    },

    getFiles(name) {
      let url = axios.defaults.baseURL;
      let imagelink = url.slice(0, -3) + "logos/" + name;
      return imagelink;
    },

    async getReceiptDetails() {
      let url = `/getsaledetail/${this.$route.query.id}`;
      const response = await axios.get(url);
      this.amountpaid = response.data.amountpaid;
      this.price_recorded = response.data.price;
    },

    commas(x) {
      return x.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ",");
    },
  },
  mounted() {
    this.showticket();
    this.getReceiptDetails();
    this.showOrder();
    setTimeout(() => {
      window.print();
      window.onafterprint = this.$router.go(-1);
    }, 1800);
  },
};
</script>
